export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automazione",
    title: "Quando vengono inviate le informazioni di arrivo?",
    desc: "Attiva ogni evento e decidi <strong>quando</strong> viene inviato: quando <strong>un ospite</strong> completa la sua registrazione, oppure solo quando <strong>tutti</strong> gli ospiti della prenotazione completano la registrazione.",
    loading: "Caricamento della configurazione…",
    welcomeName: "Messaggio di benvenuto",
    welcomeSub: `Il messaggio di benvenuto che l'ospite riceve subito dopo aver completato la registrazione.`,
    documentName: "Documento delle politiche firmato",
    documentSub: `È il documento che l'ospite firma durante il processo di registrazione. Lo inviamo in PDF affinché lo abbia sul suo WhatsApp o e-mail.`,
    timingIndividual: "Quando un ospite completa la registrazione",
    timingAll: "Quando tutti gli ospiti della prenotazione completano la registrazione",
    timingQuestion: "Quando viene inviato?",
    eventOffNote: "Questo evento non verrà inviato automaticamente.",
    infoBox: `Le modifiche vengono salvate automaticamente. La chiave di accesso, quando l'alloggio dispone di serratura intelligente, segue la propria configurazione.`,
    loadError: "Impossibile caricare la configurazione.",
    saveError: "Impossibile salvare la configurazione. Riprova.",
  },
  checkinProcess: {
    colEmail: "E-mail",
    colSendDate: "Data di invio",
    colStatus: "Stato",
    unspecified: "Non specificato",
    complete: "Completo",
    pending: "In sospeso",
  },
  listBookings: {
    title: "Elenco dei check-in",
    subtitle: "Registro degli arrivi dei tuoi ospiti",
    accommodation: "Alloggio",
    all: "Tutti",
    from: "Da",
    to: "A",
    search: "Cerca",
    today: "Oggi",
    noDate: "Senza data",
    clear: "Pulisci",
    exporting: "Esportazione...",
    exportCheckins: "Esporta",
    ricevutaBtn: "Ricevuta Polizia",
    ricevutaTitle: "Ricevuta Alloggiati Web",
    ricevutaHint: "La ricevuta ufficiale di Alloggiati Web con tutte le schedine inviate ogni giorno. Un giorno scarica un PDF; più giorni, uno ZIP con un PDF per giorno (massimo 31).",
    ricevutaFrom: "Dal",
    ricevutaTo: "Al",
    ricevutaAccount: "Account polizia",
    ricevutaDownload: "Scarica PDF",
    ricevutaDownloading: "Download…",
    ricevutaCancel: "Annulla",
    ricevutaError: "Impossibile scaricare la ricevuta.",
    noAccommodation: "Nessun alloggio",
    noReservation: "Nessuna prenotazione",
    travelerReport: "Scheda del viaggiatore (Mossos)",
    noRecords: "Nessun record",
    noRecordsFiltered: "Nessun record trovato con i filtri applicati.",
    noCheckinsTitle: "Nessun check-in registrato ancora",
    noCheckinsSub: "Quando i tuoi ospiti completano il check-in, li vedrai qui con tutte le loro informazioni.",
    excelSuccess: "Check-in scaricati in Excel",
    excelSuccessTitle: "Esportazione completata",
    excelError: "Non siamo riusciti a esportare i check-in",
    errorTitle: "Errore",
    listingNotIdentified: `Impossibile identificare l'annuncio del check-in`,
    comprobanteNotAvailable: "La ricevuta non è ancora disponibile per questo check-in",
    comprobanteDownloadError: "Impossibile scaricare la ricevuta",
  },
  modalFirstCheckin: {
    loading: "Caricamento...",
    sendingLinkWait: "Invio del link di check-in, attendere prego...",
    phoneRequired: "Per continuare devi inserire il numero di WhatsApp",
    sendingLink: "Invio del link ...",
    almostThere: "Manca poco, attendere prego...",
    sentSuccess: "Inviato con successo",
    sendError: `Errore durante l'invio del check-in`,
    title: "Prova ora un processo di check-in con il tuo telefono",
    enterWhatsapp: "Inserisci il tuo numero di WhatsApp",
    invalidNumber: `Numero non valido. Assicurati di includere il prefisso "+".`,
    skip: "Salta",
    sendFirstCheckin: "Invia il tuo primo check-in",
    sendCheckin: "Invia il check-in",
  },
  tableRetriveCheckinPending: {
    colEmail: "E-mail",
    colSendDate: "Data di invio",
    colStatus: "Stato",
    unspecified: "Non specificato",
    complete: "Completo",
    pending: "In sospeso",
    emptyMessage: "Non hai ancora check-in in corso",
  },
  rerservationModal: {
    night: "notte",
    nights: "notti",
    minStayBanner: `L'intervallo selezionato ha una restrizione di soggiorno minimo di {count} {nights} (regola OTA). Notti selezionate: {selected}.`,
    freeUnits: "Unità disponibili: {count}",
    noAvailabilityDetailed: "Nessuna disponibilità per queste date. {details}",
    noAvailability: "Nessuna disponibilità per queste date.",
    hotelAvailabilityError: "Impossibile validare la disponibilità (hotel).",
    minStayWarning: "Per il giorno di arrivo sono richieste minimo {count} notti. Ne hai selezionate {selected}.",
    notEnoughAvailability: `Non c'è disponibilità sufficiente. Unità disponibili: {count}.`,
    noAvailabilityDates: `Non c'è disponibilità per le date selezionate.`,
    departureAfterArrival: `La partenza deve essere successiva all'arrivo.`,
    close: "Chiudi",
    noMatches: "Nessuna corrispondenza",
    noAccommodations: "Nessun alloggio",
    searchingGuests: "Ricerca ospiti...",
    noName: "Senza nome",
    priceLocked: "Non è possibile modificare il prezzo della prenotazione.",
    otaMoveHint: "Puoi spostarla in un altro alloggio dello stesso annuncio; il canale viene avvisato.",
    otaMoveHintCuenta: "Puoi spostarla in uno qualsiasi dei tuoi alloggi. Se è dello stesso annuncio, il canale viene avvisato.",
    otaRelocateNote: "È un altro annuncio: viene spostata in WACheckin, ma il canale la terrà nell'alloggio in cui è stata venduta. Le sue modifiche e la cancellazione ti arriveranno comunque.",
    extrasTitle: "Altre opzioni",
    extrasSub: "Seleziona cosa addebiti e lo sconto che applichi",
    quoteTitle: "Quanto incassa la tua prenotazione diretta",
    quoteHint: "Seleziona cosa vuoi addebitare in questa prenotazione. Le notti ci sono sempre.",
    quoteOptions: "1 da selezionare | {count} da selezionare",
    quoteNoExtras: "Questo alloggio non ha pulizie né addebiti configurati nella sua prenotazione diretta.",
    quoteStay: "Soggiorno · {count} notte | Soggiorno · {count} notti",
    quoteExtraGuest: "Ospite extra | {count} ospiti extra",
    quoteDiscount: "Sconti e promozioni",
    quoteOccupancyDiscount: "Sconto per occupazione",
    quoteCleaning: "Spese di pulizia",
    quoteTotal: "Totale",
    quoteUse: "Usa questo prezzo",
    quoteNoRate: "Nessuna tariffa per quelle date: scrivi tu il prezzo.",
    quoteLinePrice: "Prezzo di questo alloggio",
    unitsAdd: "Aggiungi un altro alloggio dell’annuncio…",
    unitsGuests: "Ospiti in questo alloggio",
    unitsRemove: "Togli dalla prenotazione",
    unitsGroupError: "Non è stato possibile creare la prenotazione di più alloggi.",
    resendTitle: "Reinvia il messaggio di conferma",
    resendSub: `Reinvia il modello di conferma all'ospite.`,
    resendNote: "Modificando la prenotazione, <strong>il modello di conferma verrà reinviato</strong> per questa prenotazione.",
    saving: "Salvataggio...",
  },
};
